(() => {
  const initializeFaqCategories = (section) => {
    if (section.dataset.scrollSpyInitialized === 'true') return;

    const nav = section.querySelector('.faq-categories__nav');
    const links = Array.from(section.querySelectorAll('.faq-categories__nav-link'));
    const entries = links
      .map((link) => {
        const id = decodeURIComponent(link.hash.slice(1));
        return { link, target: document.getElementById(id) };
      })
      .filter((entry) => entry.target);

    if (!nav || !entries.length) return;

    section.dataset.scrollSpyInitialized = 'true';
    let frameRequested = false;
    let activeLink = null;

    const centerLink = (link) => {
      if (nav.scrollWidth <= nav.clientWidth) return;

      const left = link.offsetLeft - (nav.clientWidth - link.offsetWidth) / 2;
      nav.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    };

    const setActiveLink = (link, shouldCenter = false) => {
      if (activeLink === link) return;

      entries.forEach((entry) => {
        const isActive = entry.link === link;
        entry.link.classList.toggle('is-active', isActive);

        if (isActive) {
          entry.link.setAttribute('aria-current', 'true');
        } else {
          entry.link.removeAttribute('aria-current');
        }
      });

      activeLink = link;
      if (shouldCenter) centerLink(link);
    };

    const updateActiveLink = () => {
      frameRequested = false;

      const stickyTop = Number.parseFloat(window.getComputedStyle(nav).top) || 0;
      nav.classList.toggle('is-stuck', Math.abs(nav.getBoundingClientRect().top - stickyTop) <= 1);

      const activationLine = Math.max(nav.getBoundingClientRect().bottom + 24, window.innerHeight * 0.35);
      let activeEntry = entries[0];

      entries.forEach((entry) => {
        if (entry.target.getBoundingClientRect().top <= activationLine) {
          activeEntry = entry;
        }
      });

      setActiveLink(activeEntry.link, true);
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateActiveLink);
    };

    entries.forEach(({ link }) => {
      link.addEventListener('click', () => setActiveLink(link, true));
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateActiveLink();
  };

  const initializeAll = () => {
    document.querySelectorAll('.faq-categories').forEach(initializeFaqCategories);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches('.faq-categories')
      ? event.target
      : event.target.querySelector('.faq-categories');
    if (section) initializeFaqCategories(section);
  });
})();
